import { render, staticRenderFns } from "./AppLayoutLeftColumn.vue?vue&type=template&id=0f2afd52&scoped=true&"
import script from "./AppLayoutLeftColumn.vue?vue&type=script&lang=js&"
export * from "./AppLayoutLeftColumn.vue?vue&type=script&lang=js&"
import style0 from "./AppLayoutLeftColumn.vue?vue&type=style&index=0&id=0f2afd52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2afd52",
  null
  
)

export default component.exports